import { History } from 'history';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { IProfile } from '../../models/profile';
import * as profileActions from '../../store/profile/profile-actions';
import CheckboxInput from '../inputs/checkbox-input';
import { Navigation } from '../../global-functions';

interface IPatientConsentProps {
    profile?: IProfile;
    profileErrors?: any;
    profileErrorMessage?: any;
    redirectRoute: string;
    loading?: boolean;
    history: History;
    loadProfile: () => Promise<void>;
    save: () => Promise<void>;
}

export const PatientConsent: React.FC<IPatientConsentProps> = ({
    profile,
    loadProfile,
    redirectRoute,
    save,
}: IPatientConsentProps) => {
    const [profileState, setProfileState] = useState(profile!);
    const [redirect, setRedirect] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!profile) {
            loadProfile();
        } else if (profile.patientConsent) {
            setRedirect(true);
        } else {
            setProfileState({ ...profile });
        }
    }, [profile]);

    useEffect(() => {
        if (redirect) {
            //window.location.href = redirectRoute;
            Navigation.pushExternal(redirectRoute);
        }
    }, [redirect]);

    const logOut = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
        event.preventDefault();
        window.site.logOut();
    };

    const handleChange = (event: any) => {
        const { name, checked } = event.target;

        setProfileState((prevState) => ({
            ...prevState,
            [name]: checked,
        }));
    };

    const handleSave = async (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        setSaving(true);
        await save();
        setRedirect(true);
    };

    return (
        <>
            {profileState && (
                <div className="alert alert-info">
                    <form onSubmit={handleSave}>
                        <h2>
                            <FormattedMessage
                                id="Patient_Consent"
                                defaultMessage="Patient Consent"
                            />
                        </h2>
                        <div
                            className="pull-left"
                            style={{
                                marginRight: '10px',
                                marginBottom: '20px',
                            }}
                        >
                            <CheckboxInput
                                name="patientConsent"
                                label="By checking this box, I acknowledge that I have received the consent
                                    of my patients to use their protected health information to carry out
                                    treatment, payment activities, and healthcare operations."
                                checked={profileState.patientConsent}
                                onChange={handleChange}
                            />
                        </div>
                        <button
                            id="continue"
                            type="submit"
                            className="btn btn-primary"
                            disabled={!profileState.patientConsent}
                        >
                            <span>
                                {saving ? (
                                    <>
                                        <FormattedMessage id="Saving" />
                                        {' ...'}
                                    </>
                                ) : (
                                    <FormattedMessage id="Continue" />
                                )}
                            </span>
                        </button>
                        <a
                            role="button"
                            className="btn btn-default"
                            onClick={logOut}
                        >
                            <FormattedMessage id="Log_Out" />
                        </a>
                    </form>
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState, ownProps: any) => {
    let redirectRoute = '/my-account/account-summary';
    if (
        ownProps.location &&
        ownProps.location.search &&
        ownProps.location.search.startsWith('?/')
    ) {
        redirectRoute = ownProps.location.search.substring(1);
    } else if (
        !ownProps.location.pathname.startsWith('/my-account/patient-consent')
    ) {
        redirectRoute =
            '/prosite' + ownProps.location.pathname + ownProps.location.search;
    }
    return {
        profile: state.profile ? state.profile.data! : undefined,
        redirectRoute: redirectRoute,
        profileErrors: state.profile ? state.profile.errors : undefined,
        profileErrorMessage: state.profile ? state.profile.message : undefined,
    };
};

const mapDispatchToProps = {
    loadProfile: profileActions.loadProfile,
    save: profileActions.savePatientConsent,
};

const patientConsentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientConsent);

export default patientConsentContainer;
